export const getUniqueFieldCombination = (field: { id: string | number; type?: string | number; context?: number; system?: boolean }) => {
  return `id_${field.id.toString()}_type_${field.type?.toString()}_context_${field.context?.toString()}_system_${field.system?.toString()}`;
};